import userImage from "../../images/user.jpg";

const data = JSON.stringify({
  "inbox": {
    "messages": [{
      "id": 38,
      "ts": "2018-10-15UTC23:14:17",
      "typeTo": "landlord",
      "typeFrom": "tenant",
      "userIdTo": 410,
      "threadId": 26,
      "userIdFrom": 129,
      "replyToId": null,
      "messageSubject": "Issue Report: Kitchen, Appliances",
      "messageContent": "A new issue has been created, and you can keep the tenant informed by replying to this message.\r\nTenant:Sirhc Msgtenant2\r\nProperty:56 Mystery Close Liverpool L150AB\r\n\r\nSummary:\r\n\r\n\r\nDescription:\r\nI am trapped inside the oven\nPlease can you come and let me out?\nits very dark and sticky in here.\nIt reminds me of simons desk.\r\n\r\n",
      "notifyToSent": 0,
      "dateNotifyToSent": null,
      "notfyToTypeEmail": 0,
      "notfyToTypeSMS": 0,
      "deleted": 0,
      "dateDeleted": null,
      "hash": "d693d683b67729bc9186a63ffff57cfb",
      "wasSeen": 0,
      "wasRead": 0,
      "dateFirstRead": null,
      "dateLastRead": null,
      "sentOrReceived": null,
      "threadType": null,
      "fromLabel": "Sirhc Msgtenant2",
      "toLabel": "You"
    }, {
      "id": 37,
      "ts": "2018-10-15UTC23:13:26",
      "typeTo": "landlord",
      "typeFrom": "tenant",
      "userIdTo": 410,
      "threadId": 25,
      "userIdFrom": 129,
      "replyToId": null,
      "messageSubject": "Are you getting these messages dude?",
      "messageContent": "Mr Landlord are you getting these messages from your second tenant?",
      "notifyToSent": 0,
      "dateNotifyToSent": null,
      "notfyToTypeEmail": 0,
      "notfyToTypeSMS": 0,
      "deleted": 0,
      "dateDeleted": null,
      "hash": "64bd526cff335c9251d350336f1d279a",
      "wasSeen": 0,
      "wasRead": 0,
      "dateFirstRead": null,
      "dateLastRead": null,
      "sentOrReceived": null,
      "threadType": null,
      "fromLabel": "Sirhc Msgtenant2",
      "toLabel": "You"
    }, {
      "id": 36,
      "ts": "2018-10-15UTC23:12:49",
      "typeTo": "landlord",
      "typeFrom": "tenant",
      "userIdTo": 410,
      "threadId": 24,
      "userIdFrom": 129,
      "replyToId": null,
      "messageSubject": "I am your second tenant!!",
      "messageContent": "Wow this is cool now you have a message from a second tenant ... ME! \nI am Chris Msgtenant2!",
      "notifyToSent": 0,
      "dateNotifyToSent": null,
      "notfyToTypeEmail": 0,
      "notfyToTypeSMS": 0,
      "deleted": 0,
      "dateDeleted": null,
      "hash": "178cbf7976b8313634c4232e1e225569",
      "wasSeen": 0,
      "wasRead": 0,
      "dateFirstRead": null,
      "dateLastRead": null,
      "sentOrReceived": null,
      "threadType": null,
      "fromLabel": "Sirhc Msgtenant2",
      "toLabel": "You"
    }, {
      "id": 35,
      "ts": "2018-10-15UTC23:08:37",
      "typeTo": "landlord",
      "typeFrom": "tenant",
      "userIdTo": 410,
      "threadId": 23,
      "userIdFrom": 128,
      "replyToId": null,
      "messageSubject": "Issue Report: Fire",
      "messageContent": "A new issue has been created, and you can keep the tenant informed by replying to this message.\r\nTenant:Chris Msgtenant1\r\nProperty:29 Wyndham Road Chester CH15SE\r\n\r\nSummary:\r\n\r\n\r\nDescription:\r\nI appear to be on fire. Please can you help, it really is a bit of an issue.\n\nBy the way, the house is on fire too. Sorry about it.\r\n\r\n",
      "notifyToSent": 0,
      "dateNotifyToSent": null,
      "notfyToTypeEmail": 0,
      "notfyToTypeSMS": 0,
      "deleted": 0,
      "dateDeleted": null,
      "hash": "d23f6b5a347438e00dccf413ab2b2d18",
      "wasSeen": 0,
      "wasRead": 0,
      "dateFirstRead": null,
      "dateLastRead": null,
      "sentOrReceived": null,
      "threadType": null,
      "fromLabel": "Chris Msgtenant1",
      "toLabel": "You"
    }, {
      "id": 34,
      "ts": "2018-10-15UTC23:07:58",
      "typeTo": "tenant",
      "typeFrom": "landlord",
      "userIdTo": 128,
      "threadId": 22,
      "userIdFrom": 410,
      "replyToId": 33,
      "messageSubject": "RE: Issue Report: Bathroom, Electric Shower",
      "messageContent": "ok ok, I will get this electric power problem sorted out for you!\nthanks for letting me know and for attaching great images.",
      "notifyToSent": 0,
      "dateNotifyToSent": null,
      "notfyToTypeEmail": 0,
      "notfyToTypeSMS": 0,
      "deleted": 0,
      "dateDeleted": null,
      "hash": "08c46831f309be10e6ca76942d6e1b86",
      "wasSeen": 0,
      "wasRead": 0,
      "dateFirstRead": null,
      "dateLastRead": null,
      "sentOrReceived": null,
      "threadType": null,
      "fromLabel": "You",
      "toLabel": "Chris Msgtenant1"
    }, {
      "id": 33,
      "ts": "2018-10-15UTC23:06:59",
      "typeTo": "landlord",
      "typeFrom": "tenant",
      "userIdTo": 410,
      "threadId": 22,
      "userIdFrom": 128,
      "replyToId": null,
      "messageSubject": "Issue Report: Bathroom, Electric Shower",
      "messageContent": "A new issue has been created, and you can keep the tenant informed by replying to this message.\r\nTenant:Chris Msgtenant1\r\nProperty:29 Wyndham Road Chester CH15SE\r\n\r\nSummary:\r\n\r\n\r\nDescription:\r\nMr landlord, the shower is all blocked and messed up.\nCan you help?\r\n\r\n",
      "notifyToSent": 0,
      "dateNotifyToSent": null,
      "notfyToTypeEmail": 0,
      "notfyToTypeSMS": 0,
      "deleted": 0,
      "dateDeleted": null,
      "hash": "87c28cf3f123e7525783fcc2be30b9ac",
      "wasSeen": 0,
      "wasRead": 1,
      "dateFirstRead": {
        "date": "2018-10-15 23:07:35.000000",
        "timezone_type": 3,
        "timezone": "UTC"
      },
      "dateLastRead": {
        "date": "2018-10-15 23:22:40.000000",
        "timezone_type": 3,
        "timezone": "UTC"
      },
      "sentOrReceived": null,
      "threadType": null,
      "fromLabel": "Chris Msgtenant1",
      "toLabel": "You"
    }, {
      "id": 32,
      "ts": "2018-10-15UTC23:03:25",
      "typeTo": "landlord",
      "typeFrom": "tenant",
      "userIdTo": 410,
      "threadId": 21,
      "userIdFrom": 128,
      "replyToId": 31,
      "messageSubject": "RE: About the bathroom door",
      "messageContent": "Sorry mr landlord, I kicked it when i was trying to kill a fly. \nThere are lots of fly things, and cockroaches in the bathroom.. can you try and address this sometime?",
      "notifyToSent": 0,
      "dateNotifyToSent": null,
      "notfyToTypeEmail": 0,
      "notfyToTypeSMS": 0,
      "deleted": 0,
      "dateDeleted": null,
      "hash": "a125fd288a4c19f84953a036df7428d3",
      "wasSeen": 0,
      "wasRead": 0,
      "dateFirstRead": null,
      "dateLastRead": null,
      "sentOrReceived": null,
      "threadType": null,
      "fromLabel": "Chris Msgtenant1",
      "toLabel": "You"
    }, {
      "id": 31,
      "ts": "2018-10-15UTC23:02:33",
      "typeTo": "tenant",
      "typeFrom": "landlord",
      "userIdTo": 128,
      "threadId": 21,
      "userIdFrom": 410,
      "replyToId": null,
      "messageSubject": "About the bathroom door",
      "messageContent": "Hey, \n\nI was at the property the other day and i noticed that the bathroom door has been kicked, or damaged somehow. What happened? Was it the hulk?",
      "notifyToSent": 0,
      "dateNotifyToSent": null,
      "notfyToTypeEmail": 0,
      "notfyToTypeSMS": 0,
      "deleted": 0,
      "dateDeleted": null,
      "hash": "af9fd371607840e298065d852c3bdc5f",
      "wasSeen": 0,
      "wasRead": 1,
      "dateFirstRead": {
        "date": "2018-10-15 23:02:48.000000",
        "timezone_type": 3,
        "timezone": "UTC"
      },
      "dateLastRead": {
        "date": "2018-10-15 23:02:49.000000",
        "timezone_type": 3,
        "timezone": "UTC"
      },
      "sentOrReceived": null,
      "threadType": null,
      "fromLabel": "You",
      "toLabel": "Chris Msgtenant1"
    }, {
      "id": 30,
      "ts": "2018-10-15UTC23:01:52",
      "typeTo": "tenant",
      "typeFrom": "landlord",
      "userIdTo": 128,
      "threadId": 20,
      "userIdFrom": 410,
      "replyToId": 29,
      "messageSubject": "RE: My phone has changed",
      "messageContent": "ok cool, I\u0027ve changed your number in my phone. You are a wonderful tenant! \nHope you know that \u003C3",
      "notifyToSent": 0,
      "dateNotifyToSent": null,
      "notfyToTypeEmail": 0,
      "notfyToTypeSMS": 0,
      "deleted": 0,
      "dateDeleted": null,
      "hash": "c1f9d76997687113c318376b596f2a2b",
      "wasSeen": 0,
      "wasRead": 0,
      "dateFirstRead": null,
      "dateLastRead": null,
      "sentOrReceived": null,
      "threadType": null,
      "fromLabel": "You",
      "toLabel": "Chris Msgtenant1"
    }, {
      "id": 29,
      "ts": "2018-10-15UTC23:01:09",
      "typeTo": "landlord",
      "typeFrom": "tenant",
      "userIdTo": 410,
      "threadId": 20,
      "userIdFrom": 128,
      "replyToId": null,
      "messageSubject": "My phone has changed",
      "messageContent": "Hey Mr Landlord guy,\n\nI just wanted to let you know that my phone number has changed...\nits now 1234567890! wow huh!",
      "notifyToSent": 0,
      "dateNotifyToSent": null,
      "notfyToTypeEmail": 0,
      "notfyToTypeSMS": 0,
      "deleted": 0,
      "dateDeleted": null,
      "hash": "a23e5689efff80037f4e3d89322c05c0",
      "wasSeen": 0,
      "wasRead": 1,
      "dateFirstRead": {
        "date": "2018-10-15 23:01:32.000000",
        "timezone_type": 3,
        "timezone": "UTC"
      },
      "dateLastRead": {
        "date": "2018-10-15 23:01:33.000000",
        "timezone_type": 3,
        "timezone": "UTC"
      },
      "sentOrReceived": null,
      "threadType": null,
      "fromLabel": "Chris Msgtenant1",
      "toLabel": "You"
    }],
    "threads": [{
      "id": 26,
      "ts": "2018-10-15UTC23:14:17",
      "typeInitialyTo": "landlord",
      "typeInitialyFrom": "tenant",
      "firstMessageId": 38,
      "lastMessageId": 38,
      "firstUserIdTo": 410,
      "firstUserIdFrom": 129,
      "threadStartedDate": {
        "date": "2018-10-15 23:14:17.000000",
        "timezone_type": 3,
        "timezone": "UTC"
      },
      "threadLatestDate": {
        "date": "2018-10-15 23:14:17.000000",
        "timezone_type": 3,
        "timezone": "UTC"
      },
      "dateThreadLastRead": null,
      "lastReadId": null,
      "lastReadType": null,
      "numberMessages": 1,
      "threadSubject": "Issue Report: Kitchen, Appliances",
      "hash": "d6f5c51e264a4bface8e4b8c67e2c222",
      "threadRelatedItemType": "IssueReport",
      "threadRelatedItemId": 72,
      "threadRelatedItemHash": "cd8e2cd4098aff986dfcf8bee539af7a",
      "threadSubjectCurrent": "Issue Report: Kitchen, Appliances",
      "type": "thread",
      "threadType": null,
      "unreadCount": "1",
      "startedBetweenString": "Sirhc Msgtenant2 and Me"
    }, {
      "id": 25,
      "ts": "2018-10-15UTC23:13:26",
      "typeInitialyTo": "landlord",
      "typeInitialyFrom": "tenant",
      "firstMessageId": 37,
      "lastMessageId": 37,
      "firstUserIdTo": 410,
      "firstUserIdFrom": 129,
      "threadStartedDate": {
        "date": "2018-10-15 23:13:26.000000",
        "timezone_type": 3,
        "timezone": "UTC"
      },
      "threadLatestDate": {
        "date": "2018-10-15 23:13:26.000000",
        "timezone_type": 3,
        "timezone": "UTC"
      },
      "dateThreadLastRead": null,
      "lastReadId": null,
      "lastReadType": null,
      "numberMessages": 1,
      "threadSubject": "Are you getting these messages dude?",
      "hash": "55c46152bfc7cd5e68204af39da6c2c8",
      "threadRelatedItemType": null,
      "threadRelatedItemId": null,
      "threadRelatedItemHash": null,
      "threadSubjectCurrent": "Are you getting these messages dude?",
      "type": "thread",
      "threadType": null,
      "unreadCount": "1",
      "startedBetweenString": "Sirhc Msgtenant2 and Me"
    }, {
      "id": 24,
      "ts": "2018-10-15UTC23:12:49",
      "typeInitialyTo": "landlord",
      "typeInitialyFrom": "tenant",
      "firstMessageId": 36,
      "lastMessageId": 36,
      "firstUserIdTo": 410,
      "firstUserIdFrom": 129,
      "threadStartedDate": {
        "date": "2018-10-15 23:12:49.000000",
        "timezone_type": 3,
        "timezone": "UTC"
      },
      "threadLatestDate": {
        "date": "2018-10-15 23:12:49.000000",
        "timezone_type": 3,
        "timezone": "UTC"
      },
      "dateThreadLastRead": null,
      "lastReadId": null,
      "lastReadType": null,
      "numberMessages": 1,
      "threadSubject": "I am your second tenant!!",
      "hash": "08937422c9c9d86d3a73d2bc206a31bf",
      "threadRelatedItemType": null,
      "threadRelatedItemId": null,
      "threadRelatedItemHash": null,
      "threadSubjectCurrent": "I am your second tenant!!",
      "type": "thread",
      "threadType": null,
      "unreadCount": "1",
      "startedBetweenString": "Sirhc Msgtenant2 and Me"
    }, {
      "id": 23,
      "ts": "2018-10-15UTC23:08:37",
      "typeInitialyTo": "landlord",
      "typeInitialyFrom": "tenant",
      "firstMessageId": 35,
      "lastMessageId": 35,
      "firstUserIdTo": 410,
      "firstUserIdFrom": 128,
      "threadStartedDate": {
        "date": "2018-10-15 23:08:37.000000",
        "timezone_type": 3,
        "timezone": "UTC"
      },
      "threadLatestDate": {
        "date": "2018-10-15 23:08:37.000000",
        "timezone_type": 3,
        "timezone": "UTC"
      },
      "dateThreadLastRead": null,
      "lastReadId": null,
      "lastReadType": null,
      "numberMessages": 1,
      "threadSubject": "Issue Report: Fire",
      "hash": "12e39b2566685c90dcbe9b5d0a57635b",
      "threadRelatedItemType": "IssueReport",
      "threadRelatedItemId": 71,
      "threadRelatedItemHash": "ca21b68e9a50439e05e3a24ab964d017",
      "threadSubjectCurrent": "Issue Report: Fire",
      "type": "thread",
      "threadType": null,
      "unreadCount": "1",
      "startedBetweenString": "Chris Msgtenant1 and Me"
    }, {
      "id": 22,
      "ts": "2018-10-15UTC23:06:59",
      "typeInitialyTo": "landlord",
      "typeInitialyFrom": "tenant",
      "firstMessageId": 33,
      "lastMessageId": 34,
      "firstUserIdTo": 410,
      "firstUserIdFrom": 128,
      "threadStartedDate": {
        "date": "2018-10-15 23:06:59.000000",
        "timezone_type": 3,
        "timezone": "UTC"
      },
      "threadLatestDate": {
        "date": "2018-10-15 23:07:58.000000",
        "timezone_type": 3,
        "timezone": "UTC"
      },
      "dateThreadLastRead": {
        "date": "2018-10-15 23:22:43.000000",
        "timezone_type": 3,
        "timezone": "UTC"
      },
      "lastReadId": 410,
      "lastReadType": "landlord",
      "numberMessages": 2,
      "threadSubject": "Issue Report: Bathroom, Electric Shower",
      "hash": "667a7dc4fe5721ecfb07cd88fc241c82",
      "threadRelatedItemType": "IssueReport",
      "threadRelatedItemId": 70,
      "threadRelatedItemHash": "9148873f424a5ae34becbd13c88fc621",
      "threadSubjectCurrent": "RE: Issue Report: Bathroom, Electric Shower",
      "type": "thread",
      "threadType": null,
      "unreadCount": "0",
      "startedBetweenString": "Chris Msgtenant1 and Me"
    }, {
      "id": 21,
      "ts": "2018-10-15UTC23:02:33",
      "typeInitialyTo": "tenant",
      "typeInitialyFrom": "landlord",
      "firstMessageId": 31,
      "lastMessageId": 32,
      "firstUserIdTo": 128,
      "firstUserIdFrom": 410,
      "threadStartedDate": {
        "date": "2018-10-15 23:02:33.000000",
        "timezone_type": 3,
        "timezone": "UTC"
      },
      "threadLatestDate": {
        "date": "2018-10-15 23:03:25.000000",
        "timezone_type": 3,
        "timezone": "UTC"
      },
      "dateThreadLastRead": {
        "date": "2018-10-15 23:02:49.000000",
        "timezone_type": 3,
        "timezone": "UTC"
      },
      "lastReadId": 128,
      "lastReadType": "tenant",
      "numberMessages": 2,
      "threadSubject": "About the bathroom door",
      "hash": "521a18e9ddec0132537241c7f0137d29",
      "threadRelatedItemType": null,
      "threadRelatedItemId": null,
      "threadRelatedItemHash": null,
      "threadSubjectCurrent": "RE: About the bathroom door",
      "type": "thread",
      "threadType": null,
      "unreadCount": "1",
      "startedBetweenString": "Chris Msgtenant1 and Me"
    }, {
      "id": 20,
      "ts": "2018-10-15UTC23:01:10",
      "typeInitialyTo": "landlord",
      "typeInitialyFrom": "tenant",
      "firstMessageId": 29,
      "lastMessageId": 30,
      "firstUserIdTo": 410,
      "firstUserIdFrom": 128,
      "threadStartedDate": {
        "date": "2018-10-15 23:01:10.000000",
        "timezone_type": 3,
        "timezone": "UTC"
      },
      "threadLatestDate": {
        "date": "2018-10-15 23:01:52.000000",
        "timezone_type": 3,
        "timezone": "UTC"
      },
      "dateThreadLastRead": {
        "date": "2018-10-15 23:25:23.000000",
        "timezone_type": 3,
        "timezone": "UTC"
      },
      "lastReadId": 410,
      "lastReadType": "landlord",
      "numberMessages": 2,
      "threadSubject": "My phone has changed",
      "hash": "5c199c86d31a168d724ed37d7ec92c5b",
      "threadRelatedItemType": null,
      "threadRelatedItemId": null,
      "threadRelatedItemHash": null,
      "threadSubjectCurrent": "RE: My phone has changed",
      "type": "thread",
      "threadType": null,
      "unreadCount": "0",
      "startedBetweenString": "Chris Msgtenant1 and Me"
    }, {
      "id": 19,
      "ts": "2018-10-15UTC22:57:26",
      "typeInitialyTo": "landlord",
      "typeInitialyFrom": "tenant",
      "firstMessageId": 23,
      "lastMessageId": 28,
      "firstUserIdTo": 410,
      "firstUserIdFrom": 128,
      "threadStartedDate": {
        "date": "2018-10-15 22:57:26.000000",
        "timezone_type": 3,
        "timezone": "UTC"
      },
      "threadLatestDate": {
        "date": "2018-10-15 23:00:28.000000",
        "timezone_type": 3,
        "timezone": "UTC"
      },
      "dateThreadLastRead": {
        "date": "2018-10-15 23:00:15.000000",
        "timezone_type": 3,
        "timezone": "UTC"
      },
      "lastReadId": 410,
      "lastReadType": "landlord",
      "numberMessages": 6,
      "threadSubject": "Just saying hello",
      "hash": "2de6e7163b4d9efa8a2ad6d1d7542afb",
      "threadRelatedItemType": null,
      "threadRelatedItemId": null,
      "threadRelatedItemHash": null,
      "threadSubjectCurrent": "RE: RE: RE: RE: RE: Just saying hello",
      "type": "thread",
      "threadType": null,
      "unreadCount": "0",
      "startedBetweenString": "Chris Msgtenant1 and Me"
    }],
    "messagesByThreadId": {
      "26": [{
        "id": 38,
        "ts": "2018-10-15UTC23:14:17",
        "typeTo": "landlord",
        "typeFrom": "tenant",
        "userIdTo": 410,
        "threadId": 26,
        "userIdFrom": 129,
        "replyToId": null,
        "messageSubject": "Issue Report: Kitchen, Appliances",
        "messageContent": "A new issue has been created, and you can keep the tenant informed by replying to this message.\r\nTenant:Sirhc Msgtenant2\r\nProperty:56 Mystery Close Liverpool L150AB\r\n\r\nSummary:\r\n\r\n\r\nDescription:\r\nI am trapped inside the oven\nPlease can you come and let me out?\nits very dark and sticky in here.\nIt reminds me of simons desk.\r\n\r\n",
        "notifyToSent": 0,
        "dateNotifyToSent": null,
        "notfyToTypeEmail": 0,
        "notfyToTypeSMS": 0,
        "deleted": 0,
        "dateDeleted": null,
        "hash": "d693d683b67729bc9186a63ffff57cfb",
        "wasSeen": 0,
        "wasRead": 0,
        "dateFirstRead": null,
        "dateLastRead": null,
        "sentOrReceived": null,
        "threadType": null,
        "fromLabel": "Sirhc Msgtenant2",
        "toLabel": "You"
      }],
      "25": [{
        "id": 37,
        "ts": "2018-10-15UTC23:13:26",
        "typeTo": "landlord",
        "typeFrom": "tenant",
        "userIdTo": 410,
        "threadId": 25,
        "userIdFrom": 129,
        "replyToId": null,
        "messageSubject": "Are you getting these messages dude?",
        "messageContent": "Mr Landlord are you getting these messages from your second tenant?",
        "notifyToSent": 0,
        "dateNotifyToSent": null,
        "notfyToTypeEmail": 0,
        "notfyToTypeSMS": 0,
        "deleted": 0,
        "dateDeleted": null,
        "hash": "64bd526cff335c9251d350336f1d279a",
        "wasSeen": 0,
        "wasRead": 0,
        "dateFirstRead": null,
        "dateLastRead": null,
        "sentOrReceived": null,
        "threadType": null,
        "fromLabel": "Sirhc Msgtenant2",
        "toLabel": "You"
      }],
      "24": [{
        "id": 36,
        "ts": "2018-10-15UTC23:12:49",
        "typeTo": "landlord",
        "typeFrom": "tenant",
        "userIdTo": 410,
        "threadId": 24,
        "userIdFrom": 129,
        "replyToId": null,
        "messageSubject": "I am your second tenant!!",
        "messageContent": "Wow this is cool now you have a message from a second tenant ... ME! \nI am Chris Msgtenant2!",
        "notifyToSent": 0,
        "dateNotifyToSent": null,
        "notfyToTypeEmail": 0,
        "notfyToTypeSMS": 0,
        "deleted": 0,
        "dateDeleted": null,
        "hash": "178cbf7976b8313634c4232e1e225569",
        "wasSeen": 0,
        "wasRead": 0,
        "dateFirstRead": null,
        "dateLastRead": null,
        "sentOrReceived": null,
        "threadType": null,
        "fromLabel": "Sirhc Msgtenant2",
        "toLabel": "You"
      }],
      "23": [{
        "id": 35,
        "ts": "2018-10-15UTC23:08:37",
        "typeTo": "landlord",
        "typeFrom": "tenant",
        "userIdTo": 410,
        "threadId": 23,
        "userIdFrom": 128,
        "replyToId": null,
        "messageSubject": "Issue Report: Fire",
        "messageContent": "A new issue has been created, and you can keep the tenant informed by replying to this message.\r\nTenant:Chris Msgtenant1\r\nProperty:29 Wyndham Road Chester CH15SE\r\n\r\nSummary:\r\n\r\n\r\nDescription:\r\nI appear to be on fire. Please can you help, it really is a bit of an issue.\n\nBy the way, the house is on fire too. Sorry about it.\r\n\r\n",
        "notifyToSent": 0,
        "dateNotifyToSent": null,
        "notfyToTypeEmail": 0,
        "notfyToTypeSMS": 0,
        "deleted": 0,
        "dateDeleted": null,
        "hash": "d23f6b5a347438e00dccf413ab2b2d18",
        "wasSeen": 0,
        "wasRead": 0,
        "dateFirstRead": null,
        "dateLastRead": null,
        "sentOrReceived": null,
        "threadType": null,
        "fromLabel": "Chris Msgtenant1",
        "toLabel": "You"
      }],
      "22": [{
        "id": 34,
        "ts": "2018-10-15UTC23:07:58",
        "typeTo": "tenant",
        "typeFrom": "landlord",
        "userIdTo": 128,
        "threadId": 22,
        "userIdFrom": 410,
        "replyToId": 33,
        "messageSubject": "RE: Issue Report: Bathroom, Electric Shower",
        "messageContent": "ok ok, I will get this electric power problem sorted out for you!\nthanks for letting me know and for attaching great images.",
        "notifyToSent": 0,
        "dateNotifyToSent": null,
        "notfyToTypeEmail": 0,
        "notfyToTypeSMS": 0,
        "deleted": 0,
        "dateDeleted": null,
        "hash": "08c46831f309be10e6ca76942d6e1b86",
        "wasSeen": 0,
        "wasRead": 0,
        "dateFirstRead": null,
        "dateLastRead": null,
        "sentOrReceived": null,
        "threadType": null,
        "fromLabel": "You",
        "toLabel": "Chris Msgtenant1"
      }, {
        "id": 33,
        "ts": "2018-10-15UTC23:06:59",
        "typeTo": "landlord",
        "typeFrom": "tenant",
        "userIdTo": 410,
        "threadId": 22,
        "userIdFrom": 128,
        "replyToId": null,
        "messageSubject": "Issue Report: Bathroom, Electric Shower",
        "messageContent": "A new issue has been created, and you can keep the tenant informed by replying to this message.\r\nTenant:Chris Msgtenant1\r\nProperty:29 Wyndham Road Chester CH15SE\r\n\r\nSummary:\r\n\r\n\r\nDescription:\r\nMr landlord, the shower is all blocked and messed up.\nCan you help?\r\n\r\n",
        "notifyToSent": 0,
        "dateNotifyToSent": null,
        "notfyToTypeEmail": 0,
        "notfyToTypeSMS": 0,
        "deleted": 0,
        "dateDeleted": null,
        "hash": "87c28cf3f123e7525783fcc2be30b9ac",
        "wasSeen": 0,
        "wasRead": 1,
        "dateFirstRead": {
          "date": "2018-10-15 23:07:35.000000",
          "timezone_type": 3,
          "timezone": "UTC"
        },
        "dateLastRead": {
          "date": "2018-10-15 23:22:40.000000",
          "timezone_type": 3,
          "timezone": "UTC"
        },
        "sentOrReceived": null,
        "threadType": null,
        "fromLabel": "Chris Msgtenant1",
        "toLabel": "You"
      }],
      "21": [{
        "id": 32,
        "ts": "2018-10-15UTC23:03:25",
        "typeTo": "landlord",
        "typeFrom": "tenant",
        "userIdTo": 410,
        "threadId": 21,
        "userIdFrom": 128,
        "replyToId": 31,
        "messageSubject": "RE: About the bathroom door",
        "messageContent": "Sorry mr landlord, I kicked it when i was trying to kill a fly. \nThere are lots of fly things, and cockroaches in the bathroom.. can you try and address this sometime?",
        "notifyToSent": 0,
        "dateNotifyToSent": null,
        "notfyToTypeEmail": 0,
        "notfyToTypeSMS": 0,
        "deleted": 0,
        "dateDeleted": null,
        "hash": "a125fd288a4c19f84953a036df7428d3",
        "wasSeen": 0,
        "wasRead": 0,
        "dateFirstRead": null,
        "dateLastRead": null,
        "sentOrReceived": null,
        "threadType": null,
        "fromLabel": "Chris Msgtenant1",
        "toLabel": "You"
      }, {
        "id": 31,
        "ts": "2018-10-15UTC23:02:33",
        "typeTo": "tenant",
        "typeFrom": "landlord",
        "userIdTo": 128,
        "threadId": 21,
        "userIdFrom": 410,
        "replyToId": null,
        "messageSubject": "About the bathroom door",
        "messageContent": "Hey, \n\nI was at the property the other day and i noticed that the bathroom door has been kicked, or damaged somehow. What happened? Was it the hulk?",
        "notifyToSent": 0,
        "dateNotifyToSent": null,
        "notfyToTypeEmail": 0,
        "notfyToTypeSMS": 0,
        "deleted": 0,
        "dateDeleted": null,
        "hash": "af9fd371607840e298065d852c3bdc5f",
        "wasSeen": 0,
        "wasRead": 1,
        "dateFirstRead": {
          "date": "2018-10-15 23:02:48.000000",
          "timezone_type": 3,
          "timezone": "UTC"
        },
        "dateLastRead": {
          "date": "2018-10-15 23:02:49.000000",
          "timezone_type": 3,
          "timezone": "UTC"
        },
        "sentOrReceived": null,
        "threadType": null,
        "fromLabel": "You",
        "toLabel": "Chris Msgtenant1"
      }],
      "20": [{
        "id": 30,
        "ts": "2018-10-15UTC23:01:52",
        "typeTo": "tenant",
        "typeFrom": "landlord",
        "userIdTo": 128,
        "threadId": 20,
        "userIdFrom": 410,
        "replyToId": 29,
        "messageSubject": "RE: My phone has changed",
        "messageContent": "ok cool, I\u0027ve changed your number in my phone. You are a wonderful tenant! \nHope you know that \u003C3",
        "notifyToSent": 0,
        "dateNotifyToSent": null,
        "notfyToTypeEmail": 0,
        "notfyToTypeSMS": 0,
        "deleted": 0,
        "dateDeleted": null,
        "hash": "c1f9d76997687113c318376b596f2a2b",
        "wasSeen": 0,
        "wasRead": 0,
        "dateFirstRead": null,
        "dateLastRead": null,
        "sentOrReceived": null,
        "threadType": null,
        "fromLabel": "You",
        "toLabel": "Chris Msgtenant1"
      }, {
        "id": 29,
        "ts": "2018-10-15UTC23:01:09",
        "typeTo": "landlord",
        "typeFrom": "tenant",
        "userIdTo": 410,
        "threadId": 20,
        "userIdFrom": 128,
        "replyToId": null,
        "messageSubject": "My phone has changed",
        "messageContent": "Hey Mr Landlord guy,\n\nI just wanted to let you know that my phone number has changed...\nits now 1234567890! wow huh!",
        "notifyToSent": 0,
        "dateNotifyToSent": null,
        "notfyToTypeEmail": 0,
        "notfyToTypeSMS": 0,
        "deleted": 0,
        "dateDeleted": null,
        "hash": "a23e5689efff80037f4e3d89322c05c0",
        "wasSeen": 0,
        "wasRead": 1,
        "dateFirstRead": {
          "date": "2018-10-15 23:01:32.000000",
          "timezone_type": 3,
          "timezone": "UTC"
        },
        "dateLastRead": {
          "date": "2018-10-15 23:01:33.000000",
          "timezone_type": 3,
          "timezone": "UTC"
        },
        "sentOrReceived": null,
        "threadType": null,
        "fromLabel": "Chris Msgtenant1",
        "toLabel": "You"
      }]
    },
    "messagesIndexed": {
      "38": {
        "id": 38,
        "ts": "2018-10-15UTC23:14:17",
        "typeTo": "landlord",
        "typeFrom": "tenant",
        "userIdTo": 410,
        "threadId": 26,
        "userIdFrom": 129,
        "replyToId": null,
        "messageSubject": "Issue Report: Kitchen, Appliances",
        "messageContent": "A new issue has been created, and you can keep the tenant informed by replying to this message.\r\nTenant:Sirhc Msgtenant2\r\nProperty:56 Mystery Close Liverpool L150AB\r\n\r\nSummary:\r\n\r\n\r\nDescription:\r\nI am trapped inside the oven\nPlease can you come and let me out?\nits very dark and sticky in here.\nIt reminds me of simons desk.\r\n\r\n",
        "notifyToSent": 0,
        "dateNotifyToSent": null,
        "notfyToTypeEmail": 0,
        "notfyToTypeSMS": 0,
        "deleted": 0,
        "dateDeleted": null,
        "hash": "d693d683b67729bc9186a63ffff57cfb",
        "wasSeen": 0,
        "wasRead": 0,
        "dateFirstRead": null,
        "dateLastRead": null,
        "sentOrReceived": null,
        "threadType": null,
        "fromLabel": "Sirhc Msgtenant2",
        "toLabel": "You"
      },
      "37": {
        "id": 37,
        "ts": "2018-10-15UTC23:13:26",
        "typeTo": "landlord",
        "typeFrom": "tenant",
        "userIdTo": 410,
        "threadId": 25,
        "userIdFrom": 129,
        "replyToId": null,
        "messageSubject": "Are you getting these messages dude?",
        "messageContent": "Mr Landlord are you getting these messages from your second tenant?",
        "notifyToSent": 0,
        "dateNotifyToSent": null,
        "notfyToTypeEmail": 0,
        "notfyToTypeSMS": 0,
        "deleted": 0,
        "dateDeleted": null,
        "hash": "64bd526cff335c9251d350336f1d279a",
        "wasSeen": 0,
        "wasRead": 0,
        "dateFirstRead": null,
        "dateLastRead": null,
        "sentOrReceived": null,
        "threadType": null,
        "fromLabel": "Sirhc Msgtenant2",
        "toLabel": "You"
      },
      "36": {
        "id": 36,
        "ts": "2018-10-15UTC23:12:49",
        "typeTo": "landlord",
        "typeFrom": "tenant",
        "userIdTo": 410,
        "threadId": 24,
        "userIdFrom": 129,
        "replyToId": null,
        "messageSubject": "I am your second tenant!!",
        "messageContent": "Wow this is cool now you have a message from a second tenant ... ME! \nI am Chris Msgtenant2!",
        "notifyToSent": 0,
        "dateNotifyToSent": null,
        "notfyToTypeEmail": 0,
        "notfyToTypeSMS": 0,
        "deleted": 0,
        "dateDeleted": null,
        "hash": "178cbf7976b8313634c4232e1e225569",
        "wasSeen": 0,
        "wasRead": 0,
        "dateFirstRead": null,
        "dateLastRead": null,
        "sentOrReceived": null,
        "threadType": null,
        "fromLabel": "Sirhc Msgtenant2",
        "toLabel": "You"
      },
      "35": {
        "id": 35,
        "ts": "2018-10-15UTC23:08:37",
        "typeTo": "landlord",
        "typeFrom": "tenant",
        "userIdTo": 410,
        "threadId": 23,
        "userIdFrom": 128,
        "replyToId": null,
        "messageSubject": "Issue Report: Fire",
        "messageContent": "A new issue has been created, and you can keep the tenant informed by replying to this message.\r\nTenant:Chris Msgtenant1\r\nProperty:29 Wyndham Road Chester CH15SE\r\n\r\nSummary:\r\n\r\n\r\nDescription:\r\nI appear to be on fire. Please can you help, it really is a bit of an issue.\n\nBy the way, the house is on fire too. Sorry about it.\r\n\r\n",
        "notifyToSent": 0,
        "dateNotifyToSent": null,
        "notfyToTypeEmail": 0,
        "notfyToTypeSMS": 0,
        "deleted": 0,
        "dateDeleted": null,
        "hash": "d23f6b5a347438e00dccf413ab2b2d18",
        "wasSeen": 0,
        "wasRead": 0,
        "dateFirstRead": null,
        "dateLastRead": null,
        "sentOrReceived": null,
        "threadType": null,
        "fromLabel": "Chris Msgtenant1",
        "toLabel": "You"
      },
      "34": {
        "id": 34,
        "ts": "2018-10-15UTC23:07:58",
        "typeTo": "tenant",
        "typeFrom": "landlord",
        "userIdTo": 128,
        "threadId": 22,
        "userIdFrom": 410,
        "replyToId": 33,
        "messageSubject": "RE: Issue Report: Bathroom, Electric Shower",
        "messageContent": "ok ok, I will get this electric power problem sorted out for you!\nthanks for letting me know and for attaching great images.",
        "notifyToSent": 0,
        "dateNotifyToSent": null,
        "notfyToTypeEmail": 0,
        "notfyToTypeSMS": 0,
        "deleted": 0,
        "dateDeleted": null,
        "hash": "08c46831f309be10e6ca76942d6e1b86",
        "wasSeen": 0,
        "wasRead": 0,
        "dateFirstRead": null,
        "dateLastRead": null,
        "sentOrReceived": null,
        "threadType": null,
        "fromLabel": "You",
        "toLabel": "Chris Msgtenant1"
      },
      "33": {
        "id": 33,
        "ts": "2018-10-15UTC23:06:59",
        "typeTo": "landlord",
        "typeFrom": "tenant",
        "userIdTo": 410,
        "threadId": 22,
        "userIdFrom": 128,
        "replyToId": null,
        "messageSubject": "Issue Report: Bathroom, Electric Shower",
        "messageContent": "A new issue has been created, and you can keep the tenant informed by replying to this message.\r\nTenant:Chris Msgtenant1\r\nProperty:29 Wyndham Road Chester CH15SE\r\n\r\nSummary:\r\n\r\n\r\nDescription:\r\nMr landlord, the shower is all blocked and messed up.\nCan you help?\r\n\r\n",
        "notifyToSent": 0,
        "dateNotifyToSent": null,
        "notfyToTypeEmail": 0,
        "notfyToTypeSMS": 0,
        "deleted": 0,
        "dateDeleted": null,
        "hash": "87c28cf3f123e7525783fcc2be30b9ac",
        "wasSeen": 0,
        "wasRead": 1,
        "dateFirstRead": {
          "date": "2018-10-15 23:07:35.000000",
          "timezone_type": 3,
          "timezone": "UTC"
        },
        "dateLastRead": {
          "date": "2018-10-15 23:22:40.000000",
          "timezone_type": 3,
          "timezone": "UTC"
        },
        "sentOrReceived": null,
        "threadType": null,
        "fromLabel": "Chris Msgtenant1",
        "toLabel": "You"
      },
      "32": {
        "id": 32,
        "ts": "2018-10-15UTC23:03:25",
        "typeTo": "landlord",
        "typeFrom": "tenant",
        "userIdTo": 410,
        "threadId": 21,
        "userIdFrom": 128,
        "replyToId": 31,
        "messageSubject": "RE: About the bathroom door",
        "messageContent": "Sorry mr landlord, I kicked it when i was trying to kill a fly. \nThere are lots of fly things, and cockroaches in the bathroom.. can you try and address this sometime?",
        "notifyToSent": 0,
        "dateNotifyToSent": null,
        "notfyToTypeEmail": 0,
        "notfyToTypeSMS": 0,
        "deleted": 0,
        "dateDeleted": null,
        "hash": "a125fd288a4c19f84953a036df7428d3",
        "wasSeen": 0,
        "wasRead": 0,
        "dateFirstRead": null,
        "dateLastRead": null,
        "sentOrReceived": null,
        "threadType": null,
        "fromLabel": "Chris Msgtenant1",
        "toLabel": "You"
      },
      "31": {
        "id": 31,
        "ts": "2018-10-15UTC23:02:33",
        "typeTo": "tenant",
        "typeFrom": "landlord",
        "userIdTo": 128,
        "threadId": 21,
        "userIdFrom": 410,
        "replyToId": null,
        "messageSubject": "About the bathroom door",
        "messageContent": "Hey, \n\nI was at the property the other day and i noticed that the bathroom door has been kicked, or damaged somehow. What happened? Was it the hulk?",
        "notifyToSent": 0,
        "dateNotifyToSent": null,
        "notfyToTypeEmail": 0,
        "notfyToTypeSMS": 0,
        "deleted": 0,
        "dateDeleted": null,
        "hash": "af9fd371607840e298065d852c3bdc5f",
        "wasSeen": 0,
        "wasRead": 1,
        "dateFirstRead": {
          "date": "2018-10-15 23:02:48.000000",
          "timezone_type": 3,
          "timezone": "UTC"
        },
        "dateLastRead": {
          "date": "2018-10-15 23:02:49.000000",
          "timezone_type": 3,
          "timezone": "UTC"
        },
        "sentOrReceived": null,
        "threadType": null,
        "fromLabel": "You",
        "toLabel": "Chris Msgtenant1"
      },
      "30": {
        "id": 30,
        "ts": "2018-10-15UTC23:01:52",
        "typeTo": "tenant",
        "typeFrom": "landlord",
        "userIdTo": 128,
        "threadId": 20,
        "userIdFrom": 410,
        "replyToId": 29,
        "messageSubject": "RE: My phone has changed",
        "messageContent": "ok cool, I\u0027ve changed your number in my phone. You are a wonderful tenant! \nHope you know that \u003C3",
        "notifyToSent": 0,
        "dateNotifyToSent": null,
        "notfyToTypeEmail": 0,
        "notfyToTypeSMS": 0,
        "deleted": 0,
        "dateDeleted": null,
        "hash": "c1f9d76997687113c318376b596f2a2b",
        "wasSeen": 0,
        "wasRead": 0,
        "dateFirstRead": null,
        "dateLastRead": null,
        "sentOrReceived": null,
        "threadType": null,
        "fromLabel": "You",
        "toLabel": "Chris Msgtenant1"
      },
      "29": {
        "id": 29,
        "ts": "2018-10-15UTC23:01:09",
        "typeTo": "landlord",
        "typeFrom": "tenant",
        "userIdTo": 410,
        "threadId": 20,
        "userIdFrom": 128,
        "replyToId": null,
        "messageSubject": "My phone has changed",
        "messageContent": "Hey Mr Landlord guy,\n\nI just wanted to let you know that my phone number has changed...\nits now 1234567890! wow huh!",
        "notifyToSent": 0,
        "dateNotifyToSent": null,
        "notfyToTypeEmail": 0,
        "notfyToTypeSMS": 0,
        "deleted": 0,
        "dateDeleted": null,
        "hash": "a23e5689efff80037f4e3d89322c05c0",
        "wasSeen": 0,
        "wasRead": 1,
        "dateFirstRead": {
          "date": "2018-10-15 23:01:32.000000",
          "timezone_type": 3,
          "timezone": "UTC"
        },
        "dateLastRead": {
          "date": "2018-10-15 23:01:33.000000",
          "timezone_type": 3,
          "timezone": "UTC"
        },
        "sentOrReceived": null,
        "threadType": null,
        "fromLabel": "Chris Msgtenant1",
        "toLabel": "You"
      }
    },
    "sentmessages": [{
      "id": 34,
      "ts": "2018-10-15UTC23:07:58",
      "typeTo": "tenant",
      "typeFrom": "landlord",
      "userIdTo": 128,
      "threadId": 22,
      "userIdFrom": 410,
      "replyToId": 33,
      "messageSubject": "RE: Issue Report: Bathroom, Electric Shower",
      "messageContent": "ok ok, I will get this electric power problem sorted out for you!\nthanks for letting me know and for attaching great images.",
      "notifyToSent": 0,
      "dateNotifyToSent": null,
      "notfyToTypeEmail": 0,
      "notfyToTypeSMS": 0,
      "deleted": 0,
      "dateDeleted": null,
      "hash": "08c46831f309be10e6ca76942d6e1b86",
      "wasSeen": 0,
      "wasRead": 0,
      "dateFirstRead": null,
      "dateLastRead": null,
      "sentOrReceived": null,
      "threadType": null,
      "fromLabel": "You",
      "toLabel": "Chris Msgtenant1"
    }, {
      "id": 31,
      "ts": "2018-10-15UTC23:02:33",
      "typeTo": "tenant",
      "typeFrom": "landlord",
      "userIdTo": 128,
      "threadId": 21,
      "userIdFrom": 410,
      "replyToId": null,
      "messageSubject": "About the bathroom door",
      "messageContent": "Hey, \n\nI was at the property the other day and i noticed that the bathroom door has been kicked, or damaged somehow. What happened? Was it the hulk?",
      "notifyToSent": 0,
      "dateNotifyToSent": null,
      "notfyToTypeEmail": 0,
      "notfyToTypeSMS": 0,
      "deleted": 0,
      "dateDeleted": null,
      "hash": "af9fd371607840e298065d852c3bdc5f",
      "wasSeen": 0,
      "wasRead": 1,
      "dateFirstRead": {
        "date": "2018-10-15 23:02:48.000000",
        "timezone_type": 3,
        "timezone": "UTC"
      },
      "dateLastRead": {
        "date": "2018-10-15 23:02:49.000000",
        "timezone_type": 3,
        "timezone": "UTC"
      },
      "sentOrReceived": null,
      "threadType": null,
      "fromLabel": "You",
      "toLabel": "Chris Msgtenant1"
    }, {
      "id": 30,
      "ts": "2018-10-15UTC23:01:52",
      "typeTo": "tenant",
      "typeFrom": "landlord",
      "userIdTo": 128,
      "threadId": 20,
      "userIdFrom": 410,
      "replyToId": 29,
      "messageSubject": "RE: My phone has changed",
      "messageContent": "ok cool, I\u0027ve changed your number in my phone. You are a wonderful tenant! \nHope you know that \u003C3",
      "notifyToSent": 0,
      "dateNotifyToSent": null,
      "notfyToTypeEmail": 0,
      "notfyToTypeSMS": 0,
      "deleted": 0,
      "dateDeleted": null,
      "hash": "c1f9d76997687113c318376b596f2a2b",
      "wasSeen": 0,
      "wasRead": 0,
      "dateFirstRead": null,
      "dateLastRead": null,
      "sentOrReceived": null,
      "threadType": null,
      "fromLabel": "You",
      "toLabel": "Chris Msgtenant1"
    }],
    "inboxmessages": [{
      "id": 38,
      "ts": "2018-10-15UTC23:14:17",
      "typeTo": "landlord",
      "typeFrom": "tenant",
      "userIdTo": 410,
      "threadId": 26,
      "userIdFrom": 129,
      "replyToId": null,
      "messageSubject": "Issue Report: Kitchen, Appliances",
      "messageContent": "A new issue has been created, and you can keep the tenant informed by replying to this message.\r\nTenant:Sirhc Msgtenant2\r\nProperty:56 Mystery Close Liverpool L150AB\r\n\r\nSummary:\r\n\r\n\r\nDescription:\r\nI am trapped inside the oven\nPlease can you come and let me out?\nits very dark and sticky in here.\nIt reminds me of simons desk.\r\n\r\n",
      "notifyToSent": 0,
      "dateNotifyToSent": null,
      "notfyToTypeEmail": 0,
      "notfyToTypeSMS": 0,
      "deleted": 0,
      "dateDeleted": null,
      "hash": "d693d683b67729bc9186a63ffff57cfb",
      "wasSeen": 0,
      "wasRead": 0,
      "dateFirstRead": null,
      "dateLastRead": null,
      "sentOrReceived": null,
      "threadType": null,
      "fromLabel": "Sirhc Msgtenant2",
      "toLabel": "You"
    }, {
      "id": 37,
      "ts": "2018-10-15UTC23:13:26",
      "typeTo": "landlord",
      "typeFrom": "tenant",
      "userIdTo": 410,
      "threadId": 25,
      "userIdFrom": 129,
      "replyToId": null,
      "messageSubject": "Are you getting these messages dude?",
      "messageContent": "Mr Landlord are you getting these messages from your second tenant?",
      "notifyToSent": 0,
      "dateNotifyToSent": null,
      "notfyToTypeEmail": 0,
      "notfyToTypeSMS": 0,
      "deleted": 0,
      "dateDeleted": null,
      "hash": "64bd526cff335c9251d350336f1d279a",
      "wasSeen": 0,
      "wasRead": 0,
      "dateFirstRead": null,
      "dateLastRead": null,
      "sentOrReceived": null,
      "threadType": null,
      "fromLabel": "Sirhc Msgtenant2",
      "toLabel": "You"
    }, {
      "id": 36,
      "ts": "2018-10-15UTC23:12:49",
      "typeTo": "landlord",
      "typeFrom": "tenant",
      "userIdTo": 410,
      "threadId": 24,
      "userIdFrom": 129,
      "replyToId": null,
      "messageSubject": "I am your second tenant!!",
      "messageContent": "Wow this is cool now you have a message from a second tenant ... ME! \nI am Chris Msgtenant2!",
      "notifyToSent": 0,
      "dateNotifyToSent": null,
      "notfyToTypeEmail": 0,
      "notfyToTypeSMS": 0,
      "deleted": 0,
      "dateDeleted": null,
      "hash": "178cbf7976b8313634c4232e1e225569",
      "wasSeen": 0,
      "wasRead": 0,
      "dateFirstRead": null,
      "dateLastRead": null,
      "sentOrReceived": null,
      "threadType": null,
      "fromLabel": "Sirhc Msgtenant2",
      "toLabel": "You"
    }, {
      "id": 35,
      "ts": "2018-10-15UTC23:08:37",
      "typeTo": "landlord",
      "typeFrom": "tenant",
      "userIdTo": 410,
      "threadId": 23,
      "userIdFrom": 128,
      "replyToId": null,
      "messageSubject": "Issue Report: Fire",
      "messageContent": "A new issue has been created, and you can keep the tenant informed by replying to this message.\r\nTenant:Chris Msgtenant1\r\nProperty:29 Wyndham Road Chester CH15SE\r\n\r\nSummary:\r\n\r\n\r\nDescription:\r\nI appear to be on fire. Please can you help, it really is a bit of an issue.\n\nBy the way, the house is on fire too. Sorry about it.\r\n\r\n",
      "notifyToSent": 0,
      "dateNotifyToSent": null,
      "notfyToTypeEmail": 0,
      "notfyToTypeSMS": 0,
      "deleted": 0,
      "dateDeleted": null,
      "hash": "d23f6b5a347438e00dccf413ab2b2d18",
      "wasSeen": 0,
      "wasRead": 0,
      "dateFirstRead": null,
      "dateLastRead": null,
      "sentOrReceived": null,
      "threadType": null,
      "fromLabel": "Chris Msgtenant1",
      "toLabel": "You"
    }, {
      "id": 33,
      "ts": "2018-10-15UTC23:06:59",
      "typeTo": "landlord",
      "typeFrom": "tenant",
      "userIdTo": 410,
      "threadId": 22,
      "userIdFrom": 128,
      "replyToId": null,
      "messageSubject": "Issue Report: Bathroom, Electric Shower",
      "messageContent": "A new issue has been created, and you can keep the tenant informed by replying to this message.\r\nTenant:Chris Msgtenant1\r\nProperty:29 Wyndham Road Chester CH15SE\r\n\r\nSummary:\r\n\r\n\r\nDescription:\r\nMr landlord, the shower is all blocked and messed up.\nCan you help?\r\n\r\n",
      "notifyToSent": 0,
      "dateNotifyToSent": null,
      "notfyToTypeEmail": 0,
      "notfyToTypeSMS": 0,
      "deleted": 0,
      "dateDeleted": null,
      "hash": "87c28cf3f123e7525783fcc2be30b9ac",
      "wasSeen": 0,
      "wasRead": 1,
      "dateFirstRead": {
        "date": "2018-10-15 23:07:35.000000",
        "timezone_type": 3,
        "timezone": "UTC"
      },
      "dateLastRead": {
        "date": "2018-10-15 23:22:40.000000",
        "timezone_type": 3,
        "timezone": "UTC"
      },
      "sentOrReceived": null,
      "threadType": null,
      "fromLabel": "Chris Msgtenant1",
      "toLabel": "You"
    }, {
      "id": 32,
      "ts": "2018-10-15UTC23:03:25",
      "typeTo": "landlord",
      "typeFrom": "tenant",
      "userIdTo": 410,
      "threadId": 21,
      "userIdFrom": 128,
      "replyToId": 31,
      "messageSubject": "RE: About the bathroom door",
      "messageContent": "Sorry mr landlord, I kicked it when i was trying to kill a fly. \nThere are lots of fly things, and cockroaches in the bathroom.. can you try and address this sometime?",
      "notifyToSent": 0,
      "dateNotifyToSent": null,
      "notfyToTypeEmail": 0,
      "notfyToTypeSMS": 0,
      "deleted": 0,
      "dateDeleted": null,
      "hash": "a125fd288a4c19f84953a036df7428d3",
      "wasSeen": 0,
      "wasRead": 0,
      "dateFirstRead": null,
      "dateLastRead": null,
      "sentOrReceived": null,
      "threadType": null,
      "fromLabel": "Chris Msgtenant1",
      "toLabel": "You"
    }, {
      "id": 29,
      "ts": "2018-10-15UTC23:01:09",
      "typeTo": "landlord",
      "typeFrom": "tenant",
      "userIdTo": 410,
      "threadId": 20,
      "userIdFrom": 128,
      "replyToId": null,
      "messageSubject": "My phone has changed",
      "messageContent": "Hey Mr Landlord guy,\n\nI just wanted to let you know that my phone number has changed...\nits now 1234567890! wow huh!",
      "notifyToSent": 0,
      "dateNotifyToSent": null,
      "notfyToTypeEmail": 0,
      "notfyToTypeSMS": 0,
      "deleted": 0,
      "dateDeleted": null,
      "hash": "a23e5689efff80037f4e3d89322c05c0",
      "wasSeen": 0,
      "wasRead": 1,
      "dateFirstRead": {
        "date": "2018-10-15 23:01:32.000000",
        "timezone_type": 3,
        "timezone": "UTC"
      },
      "dateLastRead": {
        "date": "2018-10-15 23:01:33.000000",
        "timezone_type": 3,
        "timezone": "UTC"
      },
      "sentOrReceived": null,
      "threadType": null,
      "fromLabel": "Chris Msgtenant1",
      "toLabel": "You"
    }],
    "counts": {
      "messages": 3,
      "sent": 3,
      "threads": 8,
      "threadsWithUnread": 5,
      "messagesUnread": 5,
      "sentMessagesUnread": 2,
      "countedByThreadContents": 10,
      "allMessagesOnThreads": 16,
      "receivedMessagesOnThreads": 7,
      "sentMessagesOnThreads": 3,
      "sentMessagesRead": 1
    },
    "threadsIndexed": {
      "26": {
        "id": 26,
        "ts": "2018-10-15UTC23:14:17",
        "typeInitialyTo": "landlord",
        "typeInitialyFrom": "tenant",
        "firstMessageId": 38,
        "lastMessageId": 38,
        "firstUserIdTo": 410,
        "firstUserIdFrom": 129,
        "threadStartedDate": {
          "date": "2018-10-15 23:14:17.000000",
          "timezone_type": 3,
          "timezone": "UTC"
        },
        "threadLatestDate": {
          "date": "2018-10-15 23:14:17.000000",
          "timezone_type": 3,
          "timezone": "UTC"
        },
        "dateThreadLastRead": null,
        "lastReadId": null,
        "lastReadType": null,
        "numberMessages": 1,
        "threadSubject": "Issue Report: Kitchen, Appliances",
        "hash": "d6f5c51e264a4bface8e4b8c67e2c222",
        "threadRelatedItemType": "IssueReport",
        "threadRelatedItemId": 72,
        "threadRelatedItemHash": "cd8e2cd4098aff986dfcf8bee539af7a",
        "threadSubjectCurrent": "Issue Report: Kitchen, Appliances",
        "type": "thread",
        "threadType": null,
        "unreadCount": "1",
        "startedBetweenString": "Sirhc Msgtenant2 and Me"
      },
      "25": {
        "id": 25,
        "ts": "2018-10-15UTC23:13:26",
        "typeInitialyTo": "landlord",
        "typeInitialyFrom": "tenant",
        "firstMessageId": 37,
        "lastMessageId": 37,
        "firstUserIdTo": 410,
        "firstUserIdFrom": 129,
        "threadStartedDate": {
          "date": "2018-10-15 23:13:26.000000",
          "timezone_type": 3,
          "timezone": "UTC"
        },
        "threadLatestDate": {
          "date": "2018-10-15 23:13:26.000000",
          "timezone_type": 3,
          "timezone": "UTC"
        },
        "dateThreadLastRead": null,
        "lastReadId": null,
        "lastReadType": null,
        "numberMessages": 1,
        "threadSubject": "Are you getting these messages dude?",
        "hash": "55c46152bfc7cd5e68204af39da6c2c8",
        "threadRelatedItemType": null,
        "threadRelatedItemId": null,
        "threadRelatedItemHash": null,
        "threadSubjectCurrent": "Are you getting these messages dude?",
        "type": "thread",
        "threadType": null,
        "unreadCount": "1",
        "startedBetweenString": "Sirhc Msgtenant2 and Me"
      },
      "24": {
        "id": 24,
        "ts": "2018-10-15UTC23:12:49",
        "typeInitialyTo": "landlord",
        "typeInitialyFrom": "tenant",
        "firstMessageId": 36,
        "lastMessageId": 36,
        "firstUserIdTo": 410,
        "firstUserIdFrom": 129,
        "threadStartedDate": {
          "date": "2018-10-15 23:12:49.000000",
          "timezone_type": 3,
          "timezone": "UTC"
        },
        "threadLatestDate": {
          "date": "2018-10-15 23:12:49.000000",
          "timezone_type": 3,
          "timezone": "UTC"
        },
        "dateThreadLastRead": null,
        "lastReadId": null,
        "lastReadType": null,
        "numberMessages": 1,
        "threadSubject": "I am your second tenant!!",
        "hash": "08937422c9c9d86d3a73d2bc206a31bf",
        "threadRelatedItemType": null,
        "threadRelatedItemId": null,
        "threadRelatedItemHash": null,
        "threadSubjectCurrent": "I am your second tenant!!",
        "type": "thread",
        "threadType": null,
        "unreadCount": "1",
        "startedBetweenString": "Sirhc Msgtenant2 and Me"
      },
      "23": {
        "id": 23,
        "ts": "2018-10-15UTC23:08:37",
        "typeInitialyTo": "landlord",
        "typeInitialyFrom": "tenant",
        "firstMessageId": 35,
        "lastMessageId": 35,
        "firstUserIdTo": 410,
        "firstUserIdFrom": 128,
        "threadStartedDate": {
          "date": "2018-10-15 23:08:37.000000",
          "timezone_type": 3,
          "timezone": "UTC"
        },
        "threadLatestDate": {
          "date": "2018-10-15 23:08:37.000000",
          "timezone_type": 3,
          "timezone": "UTC"
        },
        "dateThreadLastRead": null,
        "lastReadId": null,
        "lastReadType": null,
        "numberMessages": 1,
        "threadSubject": "Issue Report: Fire",
        "hash": "12e39b2566685c90dcbe9b5d0a57635b",
        "threadRelatedItemType": "IssueReport",
        "threadRelatedItemId": 71,
        "threadRelatedItemHash": "ca21b68e9a50439e05e3a24ab964d017",
        "threadSubjectCurrent": "Issue Report: Fire",
        "type": "thread",
        "threadType": null,
        "unreadCount": "1",
        "startedBetweenString": "Chris Msgtenant1 and Me"
      },
      "22": {
        "id": 22,
        "ts": "2018-10-15UTC23:06:59",
        "typeInitialyTo": "landlord",
        "typeInitialyFrom": "tenant",
        "firstMessageId": 33,
        "lastMessageId": 34,
        "firstUserIdTo": 410,
        "firstUserIdFrom": 128,
        "threadStartedDate": {
          "date": "2018-10-15 23:06:59.000000",
          "timezone_type": 3,
          "timezone": "UTC"
        },
        "threadLatestDate": {
          "date": "2018-10-15 23:07:58.000000",
          "timezone_type": 3,
          "timezone": "UTC"
        },
        "dateThreadLastRead": {
          "date": "2018-10-15 23:22:43.000000",
          "timezone_type": 3,
          "timezone": "UTC"
        },
        "lastReadId": 410,
        "lastReadType": "landlord",
        "numberMessages": 2,
        "threadSubject": "Issue Report: Bathroom, Electric Shower",
        "hash": "667a7dc4fe5721ecfb07cd88fc241c82",
        "threadRelatedItemType": "IssueReport",
        "threadRelatedItemId": 70,
        "threadRelatedItemHash": "9148873f424a5ae34becbd13c88fc621",
        "threadSubjectCurrent": "RE: Issue Report: Bathroom, Electric Shower",
        "type": "thread",
        "threadType": null,
        "unreadCount": "0",
        "startedBetweenString": "Chris Msgtenant1 and Me"
      },
      "21": {
        "id": 21,
        "ts": "2018-10-15UTC23:02:33",
        "typeInitialyTo": "tenant",
        "typeInitialyFrom": "landlord",
        "firstMessageId": 31,
        "lastMessageId": 32,
        "firstUserIdTo": 128,
        "firstUserIdFrom": 410,
        "threadStartedDate": {
          "date": "2018-10-15 23:02:33.000000",
          "timezone_type": 3,
          "timezone": "UTC"
        },
        "threadLatestDate": {
          "date": "2018-10-15 23:03:25.000000",
          "timezone_type": 3,
          "timezone": "UTC"
        },
        "dateThreadLastRead": {
          "date": "2018-10-15 23:02:49.000000",
          "timezone_type": 3,
          "timezone": "UTC"
        },
        "lastReadId": 128,
        "lastReadType": "tenant",
        "numberMessages": 2,
        "threadSubject": "About the bathroom door",
        "hash": "521a18e9ddec0132537241c7f0137d29",
        "threadRelatedItemType": null,
        "threadRelatedItemId": null,
        "threadRelatedItemHash": null,
        "threadSubjectCurrent": "RE: About the bathroom door",
        "type": "thread",
        "threadType": null,
        "unreadCount": "1",
        "startedBetweenString": "Chris Msgtenant1 and Me"
      },
      "20": {
        "id": 20,
        "ts": "2018-10-15UTC23:01:10",
        "typeInitialyTo": "landlord",
        "typeInitialyFrom": "tenant",
        "firstMessageId": 29,
        "lastMessageId": 30,
        "firstUserIdTo": 410,
        "firstUserIdFrom": 128,
        "threadStartedDate": {
          "date": "2018-10-15 23:01:10.000000",
          "timezone_type": 3,
          "timezone": "UTC"
        },
        "threadLatestDate": {
          "date": "2018-10-15 23:01:52.000000",
          "timezone_type": 3,
          "timezone": "UTC"
        },
        "dateThreadLastRead": {
          "date": "2018-10-15 23:25:23.000000",
          "timezone_type": 3,
          "timezone": "UTC"
        },
        "lastReadId": 410,
        "lastReadType": "landlord",
        "numberMessages": 2,
        "threadSubject": "My phone has changed",
        "hash": "5c199c86d31a168d724ed37d7ec92c5b",
        "threadRelatedItemType": null,
        "threadRelatedItemId": null,
        "threadRelatedItemHash": null,
        "threadSubjectCurrent": "RE: My phone has changed",
        "type": "thread",
        "threadType": null,
        "unreadCount": "0",
        "startedBetweenString": "Chris Msgtenant1 and Me"
      },
      "19": {
        "id": 19,
        "ts": "2018-10-15UTC22:57:26",
        "typeInitialyTo": "landlord",
        "typeInitialyFrom": "tenant",
        "firstMessageId": 23,
        "lastMessageId": 28,
        "firstUserIdTo": 410,
        "firstUserIdFrom": 128,
        "threadStartedDate": {
          "date": "2018-10-15 22:57:26.000000",
          "timezone_type": 3,
          "timezone": "UTC"
        },
        "threadLatestDate": {
          "date": "2018-10-15 23:00:28.000000",
          "timezone_type": 3,
          "timezone": "UTC"
        },
        "dateThreadLastRead": {
          "date": "2018-10-15 23:00:15.000000",
          "timezone_type": 3,
          "timezone": "UTC"
        },
        "lastReadId": 410,
        "lastReadType": "landlord",
        "numberMessages": 6,
        "threadSubject": "Just saying hello",
        "hash": "2de6e7163b4d9efa8a2ad6d1d7542afb",
        "threadRelatedItemType": null,
        "threadRelatedItemId": null,
        "threadRelatedItemHash": null,
        "threadSubjectCurrent": "RE: RE: RE: RE: RE: Just saying hello",
        "type": "thread",
        "threadType": null,
        "unreadCount": "0",
        "startedBetweenString": "Chris Msgtenant1 and Me"
      }
    },
    "rawThreadsIndexed": {
      "19": {
        "message_count": "6",
        "unread": "0",
        "tot1": null,
        "fromt1": "chris",
        "fromt2": "msgtenant1",
        "toll1": "chris",
        "toll2": "msglandlord1",
        "fromll1": null,
        "fromll2": null,
        "id": "19",
        "ts": "2018-10-15UTC22:57:26",
        "type_initially_to": "landlord",
        "type_initially_from": "tenant",
        "first_message_id": "23",
        "last_message_id": "28",
        "first_user_id_to": "410",
        "first_user_id_from": "128",
        "thread_started_date": "2018-10-15 22:57:26",
        "thread_latest_date": "2018-10-15 23:00:28",
        "number_messages": "6",
        "thread_subject": "Just saying hello",
        "thread_subject_current": "RE: RE: RE: RE: RE: Just saying hello",
        "date_thread_last_read": "2018-10-15 23:00:15",
        "last_read_id": "410",
        "last_read_type": "landlord",
        "hash": "2de6e7163b4d9efa8a2ad6d1d7542afb",
        "thread_related_item_type": null,
        "thread_related_item_id": null,
        "thread_related_item_hash": null,
        "thread_type": null,
        "startedBetweenString": "Chris Msgtenant1 and Me"
      },
      "20": {
        "message_count": "2",
        "unread": "0",
        "tot1": null,
        "fromt1": "chris",
        "fromt2": "msgtenant1",
        "toll1": "chris",
        "toll2": "msglandlord1",
        "fromll1": null,
        "fromll2": null,
        "id": "20",
        "ts": "2018-10-15UTC23:01:10",
        "type_initially_to": "landlord",
        "type_initially_from": "tenant",
        "first_message_id": "29",
        "last_message_id": "30",
        "first_user_id_to": "410",
        "first_user_id_from": "128",
        "thread_started_date": "2018-10-15 23:01:10",
        "thread_latest_date": "2018-10-15 23:01:52",
        "number_messages": "2",
        "thread_subject": "My phone has changed",
        "thread_subject_current": "RE: My phone has changed",
        "date_thread_last_read": "2018-10-15 23:25:23",
        "last_read_id": "410",
        "last_read_type": "landlord",
        "hash": "5c199c86d31a168d724ed37d7ec92c5b",
        "thread_related_item_type": null,
        "thread_related_item_id": null,
        "thread_related_item_hash": null,
        "thread_type": null,
        "startedBetweenString": "Chris Msgtenant1 and Me"
      },
      "21": {
        "message_count": "2",
        "unread": "1",
        "tot1": "msgtenant1",
        "fromt1": null,
        "fromt2": null,
        "toll1": null,
        "toll2": null,
        "fromll1": "chris",
        "fromll2": "msglandlord1",
        "id": "21",
        "ts": "2018-10-15UTC23:02:33",
        "type_initially_to": "tenant",
        "type_initially_from": "landlord",
        "first_message_id": "31",
        "last_message_id": "32",
        "first_user_id_to": "128",
        "first_user_id_from": "410",
        "thread_started_date": "2018-10-15 23:02:33",
        "thread_latest_date": "2018-10-15 23:03:25",
        "number_messages": "2",
        "thread_subject": "About the bathroom door",
        "thread_subject_current": "RE: About the bathroom door",
        "date_thread_last_read": "2018-10-15 23:02:49",
        "last_read_id": "128",
        "last_read_type": "tenant",
        "hash": "521a18e9ddec0132537241c7f0137d29",
        "thread_related_item_type": null,
        "thread_related_item_id": null,
        "thread_related_item_hash": null,
        "thread_type": null,
        "startedBetweenString": "Chris Msgtenant1 and Me"
      },
      "22": {
        "message_count": "2",
        "unread": "0",
        "tot1": null,
        "fromt1": "chris",
        "fromt2": "msgtenant1",
        "toll1": "chris",
        "toll2": "msglandlord1",
        "fromll1": null,
        "fromll2": null,
        "id": "22",
        "ts": "2018-10-15UTC23:06:59",
        "type_initially_to": "landlord",
        "type_initially_from": "tenant",
        "first_message_id": "33",
        "last_message_id": "34",
        "first_user_id_to": "410",
        "first_user_id_from": "128",
        "thread_started_date": "2018-10-15 23:06:59",
        "thread_latest_date": "2018-10-15 23:07:58",
        "number_messages": "2",
        "thread_subject": "Issue Report: Bathroom, Electric Shower",
        "thread_subject_current": "RE: Issue Report: Bathroom, Electric Shower",
        "date_thread_last_read": "2018-10-15 23:22:43",
        "last_read_id": "410",
        "last_read_type": "landlord",
        "hash": "667a7dc4fe5721ecfb07cd88fc241c82",
        "thread_related_item_type": "IssueReport",
        "thread_related_item_id": "70",
        "thread_related_item_hash": "9148873f424a5ae34becbd13c88fc621",
        "thread_type": null,
        "startedBetweenString": "Chris Msgtenant1 and Me"
      },
      "23": {
        "message_count": "1",
        "unread": "1",
        "tot1": null,
        "fromt1": "chris",
        "fromt2": "msgtenant1",
        "toll1": "chris",
        "toll2": "msglandlord1",
        "fromll1": null,
        "fromll2": null,
        "id": "23",
        "ts": "2018-10-15UTC23:08:37",
        "type_initially_to": "landlord",
        "type_initially_from": "tenant",
        "first_message_id": "35",
        "last_message_id": "35",
        "first_user_id_to": "410",
        "first_user_id_from": "128",
        "thread_started_date": "2018-10-15 23:08:37",
        "thread_latest_date": "2018-10-15 23:08:37",
        "number_messages": "1",
        "thread_subject": "Issue Report: Fire",
        "thread_subject_current": "Issue Report: Fire",
        "date_thread_last_read": null,
        "last_read_id": null,
        "last_read_type": null,
        "hash": "12e39b2566685c90dcbe9b5d0a57635b",
        "thread_related_item_type": "IssueReport",
        "thread_related_item_id": "71",
        "thread_related_item_hash": "ca21b68e9a50439e05e3a24ab964d017",
        "thread_type": null,
        "startedBetweenString": "Chris Msgtenant1 and Me"
      },
      "24": {
        "message_count": "1",
        "unread": "1",
        "tot1": null,
        "fromt1": "Sirhc",
        "fromt2": "msgtenant2",
        "toll1": "chris",
        "toll2": "msglandlord1",
        "fromll1": null,
        "fromll2": null,
        "id": "24",
        "ts": "2018-10-15UTC23:12:49",
        "type_initially_to": "landlord",
        "type_initially_from": "tenant",
        "first_message_id": "36",
        "last_message_id": "36",
        "first_user_id_to": "410",
        "first_user_id_from": "129",
        "thread_started_date": "2018-10-15 23:12:49",
        "thread_latest_date": "2018-10-15 23:12:49",
        "number_messages": "1",
        "thread_subject": "I am your second tenant!!",
        "thread_subject_current": "I am your second tenant!!",
        "date_thread_last_read": null,
        "last_read_id": null,
        "last_read_type": null,
        "hash": "08937422c9c9d86d3a73d2bc206a31bf",
        "thread_related_item_type": null,
        "thread_related_item_id": null,
        "thread_related_item_hash": null,
        "thread_type": null,
        "startedBetweenString": "Sirhc Msgtenant2 and Me"
      },
      "25": {
        "message_count": "1",
        "unread": "1",
        "tot1": null,
        "fromt1": "Sirhc",
        "fromt2": "msgtenant2",
        "toll1": "chris",
        "toll2": "msglandlord1",
        "fromll1": null,
        "fromll2": null,
        "id": "25",
        "ts": "2018-10-15UTC23:13:26",
        "type_initially_to": "landlord",
        "type_initially_from": "tenant",
        "first_message_id": "37",
        "last_message_id": "37",
        "first_user_id_to": "410",
        "first_user_id_from": "129",
        "thread_started_date": "2018-10-15 23:13:26",
        "thread_latest_date": "2018-10-15 23:13:26",
        "number_messages": "1",
        "thread_subject": "Are you getting these messages dude?",
        "thread_subject_current": "Are you getting these messages dude?",
        "date_thread_last_read": null,
        "last_read_id": null,
        "last_read_type": null,
        "hash": "55c46152bfc7cd5e68204af39da6c2c8",
        "thread_related_item_type": null,
        "thread_related_item_id": null,
        "thread_related_item_hash": null,
        "thread_type": null,
        "startedBetweenString": "Sirhc Msgtenant2 and Me"
      },
      "26": {
        "message_count": "1",
        "unread": "1",
        "tot1": null,
        "fromt1": "Sirhc",
        "fromt2": "msgtenant2",
        "toll1": "chris",
        "toll2": "msglandlord1",
        "fromll1": null,
        "fromll2": null,
        "id": "26",
        "ts": "2018-10-15UTC23:14:17",
        "type_initially_to": "landlord",
        "type_initially_from": "tenant",
        "first_message_id": "38",
        "last_message_id": "38",
        "first_user_id_to": "410",
        "first_user_id_from": "129",
        "thread_started_date": "2018-10-15 23:14:17",
        "thread_latest_date": "2018-10-15 23:14:17",
        "number_messages": "1",
        "thread_subject": "Issue Report: Kitchen, Appliances",
        "thread_subject_current": "Issue Report: Kitchen, Appliances",
        "date_thread_last_read": null,
        "last_read_id": null,
        "last_read_type": null,
        "hash": "d6f5c51e264a4bface8e4b8c67e2c222",
        "thread_related_item_type": "IssueReport",
        "thread_related_item_id": "72",
        "thread_related_item_hash": "cd8e2cd4098aff986dfcf8bee539af7a",
        "thread_type": null,
        "startedBetweenString": "Sirhc Msgtenant2 and Me"
      }
    },
    "params": {
      "userId": 410,
      "userType": "landlord"
    },
    "hash": "586c1c24c2c8c3a20d1a5a433ccf1097",
    "quickcount": "5"
  }
});

export default JSON.parse(data);

const currentUser = {
  name: "Hello Dummy",
  email: "hello@dummy.io",
  image: userImage
};

export { currentUser };



// WEBPACK FOOTER //
// ./src/containers/Mail/fakeDataNew.js